import type { ILegend, ITemplateData } from "@framework/types";

export const baseSize = 700;

export const getSize: (size?: string) => number = (size = "0") => {
  return baseSize + Number(size) * 50;
};

export const palette = ["#1E88E5", "#E57373", "#689F38", "#8E24AA", "#F9A825", "#5E35B1", "#00838F"];

function clampPaletteIndex(i: number, len: number): number {
  if (!Number.isFinite(i) || i < 0) {
    return 0;
  }
  return i % len;
}

function strokeForFill(fillHex: string): string {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fillHex.trim());
  if (!m) {
    return "#666666";
  }
  const r = Math.round(parseInt(m[1], 16) * 0.72);
  const g = Math.round(parseInt(m[2], 16) * 0.72);
  const b = Math.round(parseInt(m[3], 16) * 0.72);
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
}

export function getAnalyticsBarFillAndStroke(
  value: ITemplateData,
  legends: ILegend[] | undefined,
  resolveAlarmColor: (status: number) => string,
): { fill: string; stroke: string } {
  if (value.AlarmStatus) {
    const fill = resolveAlarmColor(value.AlarmStatus);
    return { fill, stroke: strokeForFill(fill) };
  }

  let idx = 0;
  if (value.PaletteBackgroundColor != null && value.PaletteBackgroundColor !== "") {
    const parsed = parseInt(String(value.PaletteBackgroundColor), 10);
    idx = Number.isFinite(parsed) && parsed > 0 ? parsed - 1 : 0;
  } else if (legends?.length) {
    const legendIdx = legends.findIndex(l => value[l.LegendKey] === l.LegendValue);
    if (legendIdx >= 0) {
      idx = legendIdx;
    } else if (~~value.ValueNum >= 1) {
      idx = ~~value.ValueNum - 1;
    }
  } else if (~~value.ValueNum >= 1) {
    idx = ~~value.ValueNum - 1;
  }

  idx = clampPaletteIndex(idx, palette.length);
  const fill = palette[idx];
  return { fill, stroke: strokeForFill(fill) };
}
